const ConfirmPasswordAction = {
  SET: {
    CONFIRM_PASSWORD: {
      REQUEST: "ConfirmPasswordAction.Set.ConfirmPassword.Request",
      SUCCESS: "ConfirmPasswordAction.Set.ConfirmPassword.Success",
      FAILURE: "ConfirmPasswordAction.Set.ConfirmPassword.Failure",
    }
  }
}
export default ConfirmPasswordAction;